import {
    setRegLoginPath,
    setRegLoginUiConfigDefaults,
    showRegLoginLightbox,
} from '@zillow/user-session-store';

const HOME_RECS_GA_LABEL = 'homerecs/signin';
const LOGIN_PATH_NAME = '/user/acct/login/';

const REG_LOGIN_HEADER_FROM_COLLECTION =
    'Sign in or register to receive personalized recommendations';

export const handleSignInClick = () => {
    setRegLoginPath(LOGIN_PATH_NAME);
    setRegLoginUiConfigDefaults({
        headerText: REG_LOGIN_HEADER_FROM_COLLECTION,
        gaLabel: HOME_RECS_GA_LABEL,
    });
    showRegLoginLightbox();
};
